import { createContext } from "react";
import { Title } from "react-admin";
import useCurrentUser from "../../../hooks/useCurrentUser";

import CalendarGrid from "./CalendarGrid";
import { ICalendarContext } from "./types";

export const CalendarContext = createContext<ICalendarContext>({ coachId: "" });

const CoachSlotsCalendar = () => {
  const { user } = useCurrentUser();

  return (
    <>
      <Title title="Coach Calendar" />
      <CalendarContext.Provider value={{ coachId: user.id! }}>
        <CalendarGrid />
      </CalendarContext.Provider>
    </>
  );
};

export default CoachSlotsCalendar;
